export const PUBLIC_SURVEY_PATH = '/avaliation/:token';
